const KEY = "ai_bos_session";

function sanitizeProfile(profile) {
  if (!profile || typeof profile !== "object") return profile;
  const copy = Object.assign({}, profile);
  delete copy.user_password;
  delete copy.password;
  return copy;
}

export function loadSession() {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const session = JSON.parse(raw);
    if (!session || !session.profile || !session.profile.token) return null;
    return session;
  } catch (e) {
    return null;
  }
}

export function saveSession(session) {
  if (!session || !session.profile || !session.profile.token) return;
  const base = {
    profile: sanitizeProfile(session.profile),
    windowProfile: sanitizeProfile(session.windowProfile || session.profile),
    seller: session.seller || null,
    store: session.store || null,
    token: session.token || session.profile.token,
    billingMode: session.billingMode || "register",
  };
  const full = Object.assign({}, base, {
    settings: session.settings || null,
    curvas: session.curvas || [],
  });
  try {
    localStorage.setItem(KEY, JSON.stringify(full));
  } catch (e) {
    try {
      localStorage.setItem(KEY, JSON.stringify(base));
    } catch (e2) {
      console.warn("No se pudo guardar la sesión:", e2);
    }
  }
}

export function clearSession() {
  try {
    localStorage.removeItem(KEY);
    localStorage.removeItem("userToken");
    localStorage.removeItem("userProfile");
    localStorage.removeItem("sessionData");
  } catch (e) {
    /* ignore */
  }
  if (typeof window === "undefined") return;
  window.profile = null;
  window.store = null;
  window.seller = null;
  window.settings = null;
  window.curvas = [];
  window.token = null;
}

export function applySessionGlobals(session) {
  if (!session || typeof window === "undefined") return;
  window.profile = session.windowProfile || session.profile;
  window.store = session.store;
  window.seller = session.seller;
  window.settings = session.settings;
  window.curvas = session.curvas || [];
  window.token = session.token;
}
